import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import { DrawerProps as Props } from './types';
import ModuleLoaderLazy from '../../redux/ModuleLoaderLazy';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';

const Drawer = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "damz_shared" */
        './index'
      )
  )
);

export const DrawerLoadable: React.FC<Props> = props => {
  return (
    <ErrorBoundary debugComponent="DrawerLoadable">
      <Suspense fallback={<LoadingIndicator />}>
        <ModuleLoaderLazy />
        <Drawer {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
DrawerLoadable.displayName = 'DrawerLoadable';

export default DrawerLoadable;
